export const API_ADRESSE_BASE_URL = 'https://api-adresse.data.gouv.fr'
